import React from 'react';
import Navigator from './components/Navigator';

function App() {
  return (
    <div className="App">
      <Navigator />
    </div>
  );
}

export default App;
